import _ from "lodash";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import {RETURN_NOTES_TABLE_NAME} from "@/modules/constants";
import ReturnNotesSearchModel from "@/modules/return-notes/ReturnNotesSearch.model";
import ReturnNotesService from "@/modules/return-notes/ReturnNotesService";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-no',
    search: '',
    searchModel: new ReturnNotesSearchModel(),
    extraFilters: {},
    expand: 'receipt.customer.billing_address,created_by,return_note_inventories,contract_status',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['full_name'],
      defaultFields: [
        'no',
        'full_name',
        'financial_items',
        'company_name',
        'email',
        'actions',
      ],
    }
  }
};

let getDefaultFields = () => {
  return [
    {
      key: "created_at",
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-at-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "items_count",
      label: i18n.t('Returned Items'),
      sortable: false,
      tdClass: 'item-count-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "status",
      label: i18n.t('Status'),
      sortable: false,
      tdClass: 'status-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "is_collected_by_third_party",
      label: i18n.t('Collected by 3rd Party'),
      sortable: true,
      tdClass: 'is_collected_by_third_party-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      expand: ''
    }
  ]
}


export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      receipt: getDefaultTableData(),
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${RETURN_NOTES_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
          .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
          .map(c => c.expand)
          .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await ReturnNotesService.getReturnNotes(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    async updateTableSource({state}, {extraFilters, source, receipt, customer = null}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].receipt = receipt;
      state.tableData[source].customer = customer;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ReturnNotesSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {
      ...state.tableData[state.tableSource],
      ...payload
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
